module.exports = __webpack_public_path__ + "static/media/allie24.898665dd.jpg";